import React from 'react';
import { Countdown } from '../components/Countdown';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Bonuses } from '../components/Bonuses';
import { ValueStack } from '../components/ValueStack';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FooterCTA } from '../components/FooterCTA';
import { StickyBar } from '../components/StickyBar';
import { Toast } from '../components/Toast';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
export function Landing() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col font-sans selection:bg-blue-200 selection:text-blue-900 pb-20 md:pb-0" data-id="element-298">
      {/* Fixed Top Banner */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-2 px-4 shadow-md" data-id="element-299">
        <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-3 text-sm md:text-base font-medium" data-id="element-300">
          <span className="flex items-center gap-1" data-id="element-301">
            <span className="animate-pulse" data-id="element-302">🔥</span> OFERTA LIMITADA · Termina
            en
          </span>
          <Countdown initialMinutes={5} initialSeconds={0} data-id="element-303" />
          <span className="animate-pulse" data-id="element-304">⏳</span>
        </div>
      </div>

      <main className="flex-1" data-id="element-305">
        <Hero data-id="element-306" />
        <Features data-id="element-307" />
        <Bonuses data-id="element-308" />
        <Testimonials data-id="element-309" />

        {/* How it works section */}
        <section className="py-20 bg-white" data-id="element-310">
          <div className="max-w-5xl mx-auto px-4" data-id="element-311">
            <div className="text-center mb-16" data-id="element-312">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-313">
                🪜 CÓMO FUNCIONA EN LA PRÁCTICA
              </h2>
              <p className="text-lg text-slate-600" data-id="element-314">En 3 pasos simples:</p>
            </div>

            <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-315">
              <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-slate-100 -z-10" data-id="element-316"></div>

              {[{
              step: '1',
              title: 'Cargás tu marca',
              desc: 'Nombre, nicho, qué vendés y a quién. Una sola vez.'
            }, {
              step: '2',
              title: 'La IA genera todo tu material',
              desc: '50 ángulos, 20 creativos con texto integrado, biblioteca de copy y tu mapa de segmentación — en minutos.'
            }, {
              step: '3',
              title: 'Descargás, revisás y publicás',
              desc: 'Elegís lo que más te gusta, seguís el checklist "Campaña en 1 día" y lanzás. El control es tuyo.'
            }].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.2
            }} className="text-center" data-id="element-317">
                  <div className="w-24 h-24 mx-auto bg-white border-4 border-blue-50 rounded-full flex items-center justify-center text-3xl font-black text-blue-600 shadow-xl shadow-blue-900/5 mb-6" data-id="element-318">
                    {item.step}
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-319">
                    {item.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-320">{item.desc}</p>
                </motion.div>)}
            </div>
          </div>
        </section>

        <ValueStack data-id="element-321" />

        {/* Guarantee Section */}
        <section className="py-20 bg-slate-900 text-white" data-id="element-322">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-323">
            <ShieldCheck className="w-20 h-20 text-blue-400 mx-auto mb-8" data-id="element-324" />
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-325">
              🛡️ GARANTÍA 7 DÍAS
            </h2>
            <p className="text-lg text-slate-300 leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-326">
              Si en los primeros 7 días sentís que el sistema no te ayuda a
              crear mejor tu publicidad, escribinos y te devolvemos el 100% de
              tu dinero. Tu tranquilidad es lo primero.
            </p>
            <div className="inline-flex items-center gap-2 bg-white/10 px-6 py-3 rounded-full font-medium text-blue-300" data-id="element-327">
              <ShieldCheck className="w-5 h-5" data-id="element-328" />7 Días de Protección al
              Comprador
            </div>
          </div>
        </section>

        <FAQ data-id="element-329" />
        <FooterCTA data-id="element-330" />
      </main>

      <StickyBar data-id="element-331" />
      <Toast data-id="element-332" />
    </div>;
}